<body class="ltr main-body leftmenu">

    <form autocomplete="off" novalidate>
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <div class="row row-sm add-form">
                        <form autocomplete="off" class="p-0" novalidate [formGroup]="SearchRegnCountForm">
                            <div class="col-lg-12 col-md-12">
                                <div class="card custom-card">
                                    <div class="card-body">
                                        <div class=" d-flex align-items-center pl-3">
                                            <img alt="Logo" src="../../assets/img/CollegeMaster.png"
                                                class="mh-45px pb-2">
                                            <div class="ml-2">
                                                <h3 class="main-content-label mb-1"><b>
                                                        Registration Count Report
                                                    </b></h3>
                                                <p class="text-muted card-sub-title mb-0">
                                                    Registration Count Report </p>
                                            </div>
                                        </div>

                                        <hr class="mt-1 mb-2">
                                        <div class="row clearfix mt-3">
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>
                                                            Course
                                                        </mat-label>
                                                        <mat-select  #select22 placeholder="Course"
                                                            class="colorblack" formControlName="CoCode">
                                                            <mat-select-filter *ngIf="select22.focused"
                                                                [placeholder]="'Programme'" [displayMember]="'CoName'"
                                                                [array]="courseList"
                                                                (filteredReturn)="filteredCourseList =$event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredCourseList"
                                                                [value]="item.CoCode" (click)="getCollegeData(item.CoCode)">
                                                                {{item.CoCode}} - {{item.CoName}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>

                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>
                                                            College
                                                        </mat-label>
                                                        <mat-select  #select225 placeholder="College"
                                                        class="colorblack" formControlName="CgCode">
                                                        <mat-select-filter *ngIf="select225.focused"
                                                            [placeholder]="'Study Center Name'"
                                                            [displayMember]="'CgName'" [array]="collegedataList"
                                                            (filteredReturn)="filteredListCollege =$event">
                                                        </mat-select-filter>
                                                        <mat-option *ngFor="let item of filteredListCollege"
                                                            [value]="item.CgCode">
                                                            {{item.CgCode}} - {{item.CgName}}
                                                        </mat-option>
                                                    </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>


                                            <div class="row col-sm-12">
                                                <div class="col-sm-12 prpl">
                                                    <!-- <button type="button"
                                                        class="btn sz btn-primary btn-icon-text floatright ml-2 mt-1 fr">
                                                        <span style="display: contents; align-items: center;">
                                                            <img width="20vh" src="../../assets/img/exit.gif"
                                                                style="margin-right: 5px;">
                                                            Exit
                                                        </span>
                                                    </button> -->
                                                    <button type="button" (click)="back()"
                                                        class="btn size1 btn-primary btn-icon-text floatright mr-3 mt-1">
                                                        <span style="display: contents; align-items: center;">
                                                            <img width="20vh" src="../../assets/img/refresh.gif">
                                                            Reset
                                                        </span>
                                                    </button>


                                                    <button type="button" (click)="getRegnCountData()"
                                                        class="btn size1 btn-primary btn-icon-text floatright mr-3 mt-1">
                                                        <span style="display: contents; align-items: center;">
                                                            <img width="15vh" src="../../assets/img/list.gif"
                                                                style="margin-right: 7px;">
                                                            List
                                                        </span>
                                                    </button>

                                                    <button  type="button" *ngIf="table" (click)="download($event)"
                                                        class="btn size1 btn-primary btn-icon-text floatright mr-3 mt-1">
                                                        <span style="display: contents; align-items: center;">
                                                            <img width="15vh" src="../../assets/images/arrow (1).png"
                                                                style="margin-right: 7px;">
                                                            Download
                                                        </span>
                                                    </button>


                                                </div>
                                            </div>
                                        </div>
                                        <hr class="mt-3">
                                        <div class="row" *ngIf="table">
                                            <div class="col-sm-6">
                                                <b> Total Count : {{count}}</b> 
                                            </div>
                                          
                                        </div>
                                        <div class="col-sm-12 pl-0">
                                            <div *ngIf="table">
                                                <div class="table-responsive table-container" id="table">
                                                    <table class="table table-bordered text-nowrap">
                                                        <thead>
                                                            <tr class="text-left">
                                                                <th class="f600">
                                                                   Enrollment No.
                                                                </th>
                                                                <th class="f600">
                                                                    Student Name
                                                                </th>
                                                                <th class="f600">
                                                                    Email ID
                                                                </th>
                                                                <th class="f600">
                                                                    Mobile Number
                                                                </th>
                                                                <th class="f600">
                                                                    DOB
                                                                </th>
                                                                <th class="f600">
                                                                    Gender
                                                                </th>
                                                                <th class="f600">
                                                                    College
                                                                </th>
                                                                <th class="f600">
                                                                    Course
                                                                </th>
                                                                <!-- <th class="f600">
                                                                    Branch Name
                                                                </th> -->
                                                            </tr>
                                                        </thead>
                                                        <tbody class="curs">
                                                            <!-- (click)="editdata(item)" -->
                                                            <tr *ngFor="let item of RegnCoundatalist;">
                                                                <td>{{item.FinalRegNo}}</td>
                                                                <td>{{item.FullName}}</td>
                                                                <td>{{item.StuEmailId}}</td>
                                                                <td>{{item.StuMobNumber}}</td>
                                                                <td>{{item.DOB | date:'dd/MM/yyyy'}}</td>
                                                                <td>{{item.Gender}}</td>
                                                                <td>{{item.CgName}}</td>
                                                                <td>{{item.CoName}}</td>
                                                                <!-- <td>{{item.StrName}}</td> -->
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </form>
</body>